import { render, staticRenderFns } from "./CustomVColInfo.vue?vue&type=template&id=f9ca258c&"
import script from "./CustomVColInfo.vue?vue&type=script&lang=ts&"
export * from "./CustomVColInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../front_portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../front_portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
